import { createFileRoute } from '@tanstack/react-router'
import { LanguageDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import { ChangeLanguageDialog } from '@/routes/_app/-components/user-menu-components/change-language-dialog'

export const Route = createFileRoute('/@modal/settings/language')({
  staticData: { slotScope: '/_app', slotOutlet: 'userMenu' },
  pendingComponent: LanguageDialogPending,
  component: ChangeLanguageSlot,
})

function ChangeLanguageSlot() {
  const slot = useModalSlot(Route)
  return <ChangeLanguageDialog {...slot} />
}
